__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/166dd6b46e167b17807deb6f67138957adb85639c23bc936e58e128b/";